import { Component, Inject, inject, OnInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Router, Event, NavigationStart, RouterOutlet, NavigationEnd } from "@angular/router";
import { ThemeOptions } from './theme-options'
import { environment } from 'src/environments/environment'
import { Title } from '@angular/platform-browser';
import { ThemeService } from './core/services/theme.service';
import { ZohoAsapService } from './core/api-services/zoho-asap.service';
import { AnalyticsService } from './core/services/analytics.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {

  allowedUnauthenticatedRoutes: string[] = ['/', '/sign-in', '/sign-in/:invitationId', '/sign-up', '/sign-up/:invitationId', '/forgot-password', '/reset-password', '/terms', '/invitation/:id']

  title = 'American Drone Network'
  // Constructed at boot so page tracking is wired before the first navigation
  private analyticsService = inject(AnalyticsService)

  constructor(
    public globals: ThemeOptions,
    private router: Router,
    private titleService: Title,
    @Inject(DOCUMENT) private document: Document,
    private themeService: ThemeService,
    private zohoAsapService: ZohoAsapService
  ) {
    // Initialize theme service (this will apply saved theme or system preference)
    console.log('App initialized with theme:', this.themeService.getCurrentTheme());
    // const title = environment.htmlTitle || this.title
    // this.titleService.setTitle(title)

    this.router.events.subscribe((event:Event) => {

      if (event instanceof NavigationStart) {
        // if (this.globals.toggleSidebarMobile) {
        //   this.globals.toggleSidebar = true
        //   this.globals.toggleSidebarMobile = false
        // }
        // this.globals.sidebarHover = false
        // this.globals.toggleHeaderMobile = false

        // check the body element and remove any classes and styles that may have been added by the previous page
        // const body = document.querySelector('body')
        // if (body) {
        //   body.removeAttribute('style')
        // }
      }

      if (event instanceof NavigationEnd) {
        const offcanvasElement = document.querySelector('.offcanvas-lg.show') as HTMLElement

        if (offcanvasElement) {
          const angularBootstrap = (window as any).bootstrap
          const offcanvasInstance = angularBootstrap.Offcanvas.getInstance(offcanvasElement)
          offcanvasInstance?.hide()
        } else {
          // check the body element and remove any classes and styles that may have been added by the previous page
          const body = document.querySelector('body')
          if (body) {
            body.removeAttribute('style')
          }
        }
      }

    })
  }

  ngOnInit(): void {
    let faviconUrl: string = 'assets/images/favicon.png'
    if ('faviconUrl' in environment) {
      faviconUrl = environment['faviconUrl'] as string
    }
    this.setFavicon(faviconUrl)

    // Initialize Zoho Desk ASAP widget
    this.zohoAsapService.initialize();
  }

  setFavicon(faviconUrl: string): void {
    let link: HTMLLinkElement = this.document.querySelector("link[rel*='icon']") || this.document.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'shortcut icon';
    link.href = faviconUrl;
    this.document.getElementsByTagName('head')[0].appendChild(link);
  }
}
